import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    "quantity",
    "rate",
    "tax_rate",
    "total",
    "display_total",
    "net_amount",
    "tax_included_in_price",
  ]

  currencify(amount) {
    return Number(amount).toLocaleString() + ` ${_global_currency_code}`
  }
  calculateTotal() {
    const quantity = this.quantityTarget.value
    let rate = this.rateTarget.value
    let vatInclusiveRate
    const tax_rate = parseFloat(this.tax_rateTarget.value)
    const vatInclusive = this.tax_included_in_priceTarget?.checked
    let total = quantity * rate
    let taxAmount

    if (vatInclusive) {
      vatInclusiveRate = rate
      rate = (vatInclusiveRate / (1 + tax_rate / 100)).toFixed(2)
      total = (quantity * rate).toFixed(2)
      taxAmount = (vatInclusiveRate * quantity - total).toFixed(2)
    } else {
      taxAmount = total * (tax_rate / 100)
    }

    this.display_totalTarget.innerHTML = this.currencify(total)
    this.data.set("total", total)
    this.data.set("tax-amount", taxAmount)
  }
}
